import { Component, ViewContainerRef, OnInit } from '@angular/core';
import * as $ from 'jquery';

import {Router} from '@angular/router';
import { GlobalState } from './global.state';
import { Observable } from 'rxjs/Observable';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { layoutPaths } from './theme/theme.constants';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  template: `
    <main [class.menu-collapsed]="isMenuCollapsed" baThemeRun>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>
  `
})
export class App implements OnInit {
  user: Observable<firebase.User>;
  isMenuCollapsed: boolean = false;

  constructor(
              private _state: GlobalState,
              private _imageLoader: BaImageLoaderService,
              private _spinner: BaThemeSpinner,
              private viewContainerRef: ViewContainerRef,
              private themeConfig: BaThemeConfig,
              public afAuth: AngularFireAuth,
              private router: Router
            ) {
    this.user = afAuth.authState;
    themeConfig.config();

    this._loadImages();

    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
  }

  ngOnInit() {
    this.afAuth.authState.subscribe(user => {
          if (this.user) {
            // go to home page
            this.router.navigate(['pages/dashboard']);
          } else {
            // go to login page
            this.router.navigate(['login']);
          }
        });

  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  private _loadImages(): void {
    // register some loaders
    BaThemePreloader.registerLoader(this._imageLoader.load('/assets/img/sky-bg.jpg'));
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts